import styles from "./home.module.css";
import image from "../../assets/images/Screenshot__330_-removebg-preview.svg";
import { IoMdArrowDropdownCircle } from "react-icons/io";
import SearchBar from "components/homeComponent/search/Search";
import { useEffect, useState } from "react";

function ShowCase() {
  return (
    <div className={`d-flex ${styles.showCaseContainer}`}>
      <img className={styles.showCaseImg} src={image} />
      <div className={`w-75 d-block my-5 ${styles.divTweet}`}>
        <div
          className={`d-flex  flex-column text-white ${styles.showCaseTweet}`}
        >
          <div className="d-flex  mx-4">
            <img className={styles.tweetImg} src={image} />
            <p className="my-4 mx-3 ">rami @rami</p>
          </div>
          <p className={`text-justify mx-4 ${styles.autoText}`}>
            خبر بسیار مهم ایرانخودرو ایران خودرو برنامه واگذاری شرکتهای غیربورسی
            خود از طریق پذیرش در بازار سرمایه و عرضه اولیه آنها را در دست اقدام
            دارد. عرضه اولیه سمند نزدیکه ....
          </p>
          <div className="text-center d-flex justify-content-center">
            <p>رفتن به توییت ها</p>
            <IoMdArrowDropdownCircle className={styles.downIcon} />
          </div>
        </div>

        <SearchBar />
      </div>
    </div>
  );
}

export default ShowCase;
